import { apiMethods } from '~/services/api';
import {
  IApiConversation,
  IApiConversationResponse,
  IConversation,
  IConversationResponse,
} from '~/models/Conversation';
import { IMessage } from '~/models/Message';

export interface IGetConversationsParams {
  page: number;
  limit: number;
  status?: 'unread';
}

// GOTU-5602: keep the API's `user_last_reed` misspelling out of the rest of the app.
function normalizeConversation({
  user_last_reed: userLastReed,
  ...conversation
}: IApiConversation): IConversation {
  return { ...conversation, user_last_read: userLastReed };
}

async function getConversations(params: IGetConversationsParams): Promise<IConversationResponse> {
  const response: IApiConversationResponse = await apiMethods.getMessagesRequest(params);

  return { ...response, conversations: (response?.conversations ?? []).map(normalizeConversation) };
}

async function getJobMessages(jobId: string): Promise<IMessage[]> {
  return apiMethods.getMessagesByJobIdRequest(jobId);
}

async function postMessage(payload: { jobId: string; message: string }): Promise<IMessage> {
  return apiMethods.postMessageRequest(payload);
}

async function markConversationRead(jobId: string): Promise<void> {
  await apiMethods.markMessagesReadRequest(jobId);
}

export const messagesService = {
  getConversations,
  getJobMessages,
  postMessage,
  markConversationRead,
};
